var map = {
	"./error/error.module": [
		"./src/app/error/error.module.ts",
		"error-error-module"
	],
	"./homepage/homepage.module": [
		"./src/app/homepage/homepage.module.ts",
		"homepage-homepage-module"
	],
	"./result/result.module": [
		"./src/app/result/result.module.ts",
		"result-result-module~survey-survey-module",
		"common",
		"result-result-module"
	],
	"./selection/selection.module": [
		"./src/app/selection/selection.module.ts",
		"common",
		"selection-selection-module"
	],
	"./survey/survey.module": [
		"./src/app/survey/survey.module.ts",
		"result-result-module~survey-survey-module",
		"common",
		"survey-survey-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;